// ex) A submenu plugin that appends the contents of the input element to the editor
const venue  = {
    // plugin name (Required)
    name: 'MeetingVenue',

    // add function - It is called only once when the plugin is first run.
    // This function generates HTML to append and register the event.
    // arguments - (core : core object, targetElement : clicked button element)
    add: function (core, targetElement) {

        // Registering a namespace for caching as a plugin name in the context object
        const context = core.context;
        context.custom = {
            textElement: null
        };

        // Generate submenu HTML
        // Always bind "core" when calling a plugin function
        let listDiv = this.setSubmenu.call(core);
        // You must bind "core" object when registering an event.

        /** add event listeners */
        var self = this;
        listDiv.querySelectorAll('.se-btn-list').forEach(function (btn) {
            btn.addEventListener('click', self.onClick.bind(core));
        });

        /** append html */
        targetElement.parentNode.appendChild(listDiv);

        // @Required
        // You must add the "submenu" element using the "core.initMenuTarget" method.
        /** append target button menu */
        core.initMenuTarget(this.name, targetElement, listDiv);
    },

    setSubmenu: function () {
        const listDiv = this.util.createElement('DIV');
        // @Required
        // A "se-submenu" class is required for the top level element.
        listDiv.className = 'se-submenu se-list-layer';
        listDiv.innerHTML = '<div class="se-list-inner se-list-font-size"><ul class="se-list-basic"><li><button type="button" class="se-btn-list" value="::Meeting Town::">town</button></li><li><button type="button" class="se-btn-list" value="::Meeting Building::">building</button></li><li><button type="button" class="se-btn-list" value="::Meeting Room::">room</button></li></ul></div>'

        return listDiv;
    },

    // Called after the submenu has been rendered
    // on: function () {
    //     // Get Input value
    //     let value = this.util.createTextNode('::Meeting Venue::');

    //     // insert
    //     this.insertNode(value);

    //     // set range
    //     this.setRange(value, value.length, value, value.length);

    //     // submenu off
    //     this.submenuOff();

    //     // focus
    //     this.focus();
    // },

    onClick: function (e) {
        const value = e.target.value;
        let node = this.util.createTextNode(value);

        // insert
        this.insertNode(node);

                // set range
        this.setRange(value, value.length, value, value.length);


        // submenu off
        this.submenuOff();

        // focus
        this.focus();
    }
}
export default venue